<div ngbDropdown placement="bottom-right" class="kt-header__topbar-item kt-header__topbar-item--user" *ngIf="loaded" style="height: 100%;">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<div class="topbar-item" data-placement="bottom">
			<div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2" id="kt_quick_user_toggle">
				<ng-container *ngIf="greeting">
					<span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Bienvenido / Welcome,</span>
				</ng-container>
				<span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
					{{fullname}}
				</span>
				<span class="symbol symbol-35 symbol-light-success">
					<span class="symbol-label font-size-h5 font-weight-bold">
						{{fullname|firstLetter}}
					</span>
				</span>
			</div>
		</div>
	</div>
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-md">
		<div class="p-4">
			<!--begin: Head -->
			<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x d-flex w-60">
				<span class="symbol symbol-35 symbol-light-success">
					<span class="symbol-label font-size-h5 font-weight-bold" style="height: 6rem; width: 6rem;">{{fullname|firstLetter}}</span>
				</span>
				<div class="kt-user-card__name pl-4 pr-1">
					<a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
						{{fullname}}
					</a>
					<div class="text-muted mt-1 mb-2">{{role}}</div>
					<a (click)="logout()" class="btn btn-light-primary btn-bold">
						Cerrar sesión
					</a>
				</div>
			</div>
			<!--end: Head -->
		</div>
	</div>
</div>
